import { useEffect, useState } from "react";
import { api, friendlyError } from "@/lib/api";
import { TrustBadge } from "@/components/app/TrustBadge";
import { toast } from "sonner";

const LEVELS = ["verified", "pending", "info_provided", "unverified"];

export default function AdminSuppliers() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/suppliers").then(({data}) => setItems(data));
  useEffect(() => { load(); }, []);
  const setLevel = async (id, level) => {
    try { await api.patch(`/admin/suppliers/${id}/trust`, { trust_level: level }); toast.success("Trust level updated"); load(); }
    catch (e) { toast.error(friendlyError(e)); }
  };
  return (
    <div className="space-y-6">
      <div>
        <div className="eyebrow mb-2">Suppliers</div>
        <h1 className="page-title">Supplier directory</h1>
        <p className="text-sm text-slate-500 mt-1">Set trust levels transparently. Never mark a supplier verified without evidence.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {items.map((s) => (
          <div key={s.id} className="surface p-5" data-testid={`admin-supplier-${s.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="font-semibold tracking-tight truncate">{s.company_name}</div>
                <div className="text-xs text-slate-500 mt-0.5">{s.country} · {s.is_demo ? "Demo" : "Real"}</div>
              </div>
              <TrustBadge level={s.trust_level}/>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {LEVELS.map(l => (
                <button key={l} onClick={() => setLevel(s.id, l)} className={`text-xs px-2 py-1 rounded border transition-colors ${s.trust_level === l ? "border-[hsl(var(--gold))] text-[hsl(var(--gold))]" : "border-slate-200 text-slate-600 hover:border-slate-400"}`} data-testid={`set-trust-${l}-${s.id}`}>Set {l}</button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
